import React from 'react';
import styles from './GamesPlayedCell.module.scss';
export const GamesPlayedCell = ({ totalGamesPlayed })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.gamesCell
    }, totalGamesPlayed);
